import React, { Suspense } from "react";
import { Spin } from "antd";
const NotificationCampaignsContainer = React.lazy(
  () => import("../../../modules/NotificationCampaigns/components/index")
);

const NotificationCampaignsPage = () => (
  <Suspense fallback={<Spin />}>
    <NotificationCampaignsContainer />
  </Suspense>
);

export default NotificationCampaignsPage;
